import { ButtonHTMLAttributes } from 'react';
import { Button } from '../Button';

type ButtonPrimaryProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  title: string;
  size?: 'sm' | 'lg' | 'md';
  color?: 'primary' | 'secondary';
};

export function ButtonOutline({
  title,
  size,
  color = 'secondary',
  ...rest
}: ButtonPrimaryProps) {
  return (
    <Button color={color} size={size} isOutline={true} {...rest}>
      {title}
    </Button>
  );
}
